import React from 'react'
import { type BackTarget } from '@components/BackLink'
import PageHeading from '@components/PageHeading'
import { PageActions, PageHeaderRow } from './Page.styles'

interface PageHeaderProps {
	title: string
	/** Count / context line under the title, e.g. "3 flights". */
	subtitle?: string
	/** The page's parent; renders the back arrow left of the title. */
	backTo?: BackTarget
	/** The row's right side: the page's Button presets. */
	actions?: React.ReactNode
}

/**
 * The standard page header: the section heading on the left, its actions on
 * the right. A page is `PageScroll` holding a `PageColumn` that opens with
 * this row; the column, gutters and heading never get rebuilt per page.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, backTo, actions }) => (
	<PageHeaderRow>
		<PageHeading title={title} subtitle={subtitle} backTo={backTo} />
		{actions && <PageActions>{actions}</PageActions>}
	</PageHeaderRow>
)
